import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const OrderButton = ({ count, increment, decrement }) => {
  return (
    <div style={{ display: "flex",alignItems:"center", border: '1px solid grey', borderRadius: '5px',padding:'4px' }}>
      <MinusOutlined onClick={decrement} style={{marginRight:"3px"}} />
      {count} <PlusOutlined onClick={increment} style={{marginLeft:"3px"}}/>
    </div>
  );
};

export default OrderButton;
